import KeycloakService from '@/services/Auth/KeycloakService'

export default function (to) {
	if (to.name === 'signin') {
		KeycloakService.redirectToKeycloakLogin()
	}
	return true
}